import styled, { css } from "styled-components";
import { lighten } from "polished";

import { IStyleProps } from "./interfaces";
import { experienceEasterPath } from "../../../../paths";

export const ScoreWrapper = styled.div<IStyleProps>`
    overflow: hidden;
    margin-top: 60px;
    height: calc(100% - 60px - 102px);
    ${p => p.isEaster && css`
        margin-top: 85px;
        margin-left: 116px;
        margin-right: 88px;
        margin-bottom: 66px;
        height: calc(100% - 60px - 115px - 132px);
    `}
    ${p =>
        p.isLow
            ? css`
                  height: 270px;
                  width: 720px;
                  margin: auto;
                  margin-top: 120px;
                  border-radius: 30px;
                  border: 2px solid black;
                  -webkit-mask-image: -webkit-radial-gradient(white, black);
              `
            : undefined}
`;

export const EasterBackground = styled.div`
    background-image: url("${experienceEasterPath}/easter-score-background.svg");
    background-size: 100% 100%;
    position: absolute;
    top: 34px;
    left: 4px;
    right: -6px;
    bottom: 165px;
    z-index: -1;
`;

const padding = 20;
export const ChristmasBackground = styled.div`
    background-color: ${p => p.theme.c.christmasBlue};
    box-shadow: 0 0 0 6px ${p => p.theme.c.christmasLightBlue} inset;
    position: absolute;
    top: ${85 - padding}px;
    left: ${116 - padding}px;
    right: ${88 - padding}px;
    bottom: ${222 - padding}px;
    z-index: -1;
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    pointer-events: none;

    img {
        width: 228px;
    }
`;

export const Asset2Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 300px;
    pointer-events: none;
    img {
        width: 588px;
    }
`;

export const Asset3Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    pointer-events: none;
    img {
        width: 387px;
    }
`;

export const recBtnDimension = 80;
export const recBtnDimensionLow = 60;

export const RecBtn = styled.button<IStyleProps>`
    position: absolute;
    bottom: ${p => (p.isLow ? 230 : 20)}px;
    left: ${p => (1280 - (p.isLow ? recBtnDimensionLow : recBtnDimension)) / 2}px;
    width: ${p => (p.isLow ? recBtnDimensionLow : recBtnDimension)}px;
    height: ${p => (p.isLow ? recBtnDimensionLow : recBtnDimension)}px;
    border-radius: ${p => (p.isLow ? recBtnDimensionLow : recBtnDimension) / 2}px;
    background-color: ${p => p.theme.c.record};
    border: none;
    box-shadow: 0 0 0 2px ${p => p.theme.mode === "dark" ? p.theme.c.white : p.theme.c.black} inset;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    outline: none;
    transition: background-color 300ms;
    .i-stop {
        color: ${p => p.theme.c.whiteOnActive};
        font-size: ${p => (p.isLow ? 33 : 44)}px;
    }
    svg {
        display: block;
        fill: ${p => p.theme.c.whiteOnActive};
    }

    &:disabled {
        cursor: default;
        background-color: ${p => lighten(0.2, p.theme.c.record)};
    }

    ${p => p.isEaster && css`
        background-color: transparent;
        background-image: url("${experienceEasterPath}/record-button.svg");
        background-size: 100% 100%;
        box-shadow: none;
        width: 200px;
        padding-right: 3px !important;
        height: 200px;
        left: ${(1280 - 200) / 2}px;
        bottom: -10px;

        :active {
            box-shadow: none;
        }

        &:disabled {
            cursor: default;
            background-color: transparent;
            opacity: 0.7;
        }
    `}
`;

export const OctaveSelectors = styled.div<IStyleProps>`
    position: absolute;
    bottom: ${p => (p.isLow ? 230 : p.isEaster ? 50 : 20)}px;
    right: ${p => (p.isLow ? 280 : 100)}px;
`;

export const OctaveButton = styled.button<IStyleProps>`
    width: ${p => (p.isLow ? recBtnDimensionLow : recBtnDimension)}px;
    height: ${p => (p.isLow ? recBtnDimensionLow : recBtnDimension)}px;
    border-radius: ${p => (p.isLow ? recBtnDimensionLow : recBtnDimension) / 2}px;
    cursor: pointer;
    outline: none;
    margin: 0 ${p => (p.isLow ? 15 : 20)}px;
    border: solid 2px ${p => p.theme.mode === "dark" ? p.theme.c.white : p.theme.c.black};
    background-color: ${p => p.theme.c.whiteOnActive};
    transition: color 300ms, background-color 300ms;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    span {
        font-size: ${p => (p.isLow ? 48 : 60)}px;
        color: ${p => p.theme.c.pale};
    }

    &.Active {
        background-color: ${p => p.theme.c.active};
        span {
            color: ${p => p.theme.c.info};
        }
    }
`;

export const OctaveConnector = styled.div<IStyleProps>`
    position: absolute;
    top: ${p => (p.isLow ? 30 : 40)}px;
    right: ${p => (p.isLow ? 75 : 100)}px;
    width: ${p => (p.isLow ? 30 : 40)}px;
    height: 2px;
    background-color: ${p => p.theme.mode === "dark" ? p.theme.c.white : p.theme.c.black};
`;

export const UseSafari = styled.div`
    position: absolute;
    text-align: center;
    bottom: 30px;
    left: 0;
    right: 0;
    font-size: 28px;
`;
